import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Banner from './Banner';
import InsideContact from './InsideContact';


class TechnologySupport extends Component {
    omponentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div>
                <Banner
                    headText="Technology Support"
                    subHeadText="Design, implementation and support options to keep your business technologies humming 24/7"
                    subBoldText="INNOVATIVE. AFFORDABLE. PRACTICAL."
                    img="interior-1.jpg"
                />
                <div className="main-container">
                    <div className="container">
                        <div className="row">


                            <div className="col-lg-9 col-md-6 col-sm-12 margin5-0">
                                <h4>YOU FOCUS ON THE COMPETITION, WE FOCUS KEEPING YOU COMPETITIVE.</h4>
                                <p>
                                    Your time is valuable and needs to be invested in your business, not in managing your technology resources.
                                    At Automated Concepts we can help accomplish this goal by expertly providing the professional support 
                                    and security needed to keep your technology assets optimized and trouble free. With one of our 
                                    customized support programs, we can remove you from the distractions IT issues can raise and leave you free to make your business successful.
                                </p>
                                <br />
                                <h4>SOUND SECURITY AT THE CORE</h4>
                                <p>
                                    When we craft a customized Technology Support Package (TSP) for your business, 
                                    you get the bonus of knowing your critical IT resources are in safe and secure hands. 
                                    Automated Concepts is not just another repair call center, we treat you like family. We employ dynamic, 
                                    proactive measures to thwart failures and minimize down time, keeping you up and running through the 
                                    best practices available. With our expertise you can rest secure knowing our professional support 
                                    team is behind you 24/7.
                                </p>
                                <br />
                                <h4>ENTERPRISE LEVEL CARE AT SMALL BUSINESS COSTS</h4>
                                <p>
                                    Professional, reliable IT support doesn’t have to cost an arm and a leg. We understand SMBs and the 
                                    critical margins they work under. That's why we don’t offer off the shelf products for IT solutions.
                                    We craft scalable, practical packages that address your specific needs without overlapping costs or unnecessary coverages.  
                                    Contact us today let us share with you support solutions that can meet any budgetary constraints. Surprisingly affordable. 
                                    Reliably efficient.
                                </p>
                            </div>

                            <InsideContact />

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(TechnologySupport);


// WEBPACK FOOTER //
// ./src/components/TechnologySupport.js